var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 26.75v-1.417h13.333v1.417Zm0-12.083V13.25h13.333v1.417Zm21.875 15-4.708-4.75.958-.959 3.75 3.709 7.167-7.209 1 1.042Zm0-12.042-4.708-4.75.958-.958 3.75 3.708 7.167-7.208 1 1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTasks);
export default __webpack_public_path__ + "static/media/icon-tasks.606c3d26b3a6e0716e3d680fdee30366.svg";
export { ForwardRef as ReactComponent };